import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faUserFriends, faPlus, faMessage, fa9, faUser } from '@fortawesome/free-solid-svg-icons';

function BottomNavbar() {
  return (
      <div className="bottom-navbar">
        <div className="nav-item">
          <FontAwesomeIcon icon={faHouse} className="icon active" />
          <span className="item-name active">首页</span>
        </div>
        <div className="nav-item">
          <FontAwesomeIcon icon={faUserFriends} className="icon" />
          <span className="item-name">朋友</span>
        </div>
        <div className="nav-item-home">
          <FontAwesomeIcon icon={faPlus} className="plus" />
        </div>
        <div className="nav-item">
          <FontAwesomeIcon icon={fa9} className="notification" />
          <FontAwesomeIcon icon={faMessage} className="icon" />
          <span className="item-name">收件箱</span>
        </div>
        <div className="nav-item">
          <FontAwesomeIcon icon={faUser} className="icon" />
          <span className="item-name">我的</span>
        </div>
      </div>
  );
}

export default BottomNavbar;
